import React from 'react';
import '../../App.css'
// import { useLocation } from 'react-router-dom';



const Marker = (props: any) => {
  // const location = useLocation();
  // console.log(location,"locati0n");
    const { color, name, id } = props;
    return (
      <div className="marker"
        style={{ backgroundColor: color, cursor: 'pointer'}}
        title={name}
      />
    );
  };

  export default Marker;